import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Login from "./Pages/Login/Login";
import Layout from "./Layout/Layout";

import CmsAdd from "./Pages/Cms/CmsAdd";
import CmsList from "./Pages/Cms/CmsList";
import CmsEdit from "./Pages/Cms/CmsEdit";

import AssetAdd from "./Pages/Asset/AssetAdd";
import AssetList from "./Pages/Asset/AssetList";
import AssetEdit from "./Pages/Asset/AssetEdit";

import UserAdd from "./Pages/User/UserAdd";
import UserList from "./Pages/User/UserList";
import UserEdit from "./Pages/User/UserEdit";
import { ToastContainer } from "react-toastify";
import NetworkList from "./Pages/Network/NetworkList";
import NetworkAdd from "./Pages/Network/NetworkAdd";
import NetworkEdit from "./Pages/Network/NetworkEdit";
import CategoryList from "./Pages/Category/CategoryList";
import CategoryEdit from "./Pages/Category/CategoryEdit";
import CategoryAdd from "./Pages/Category/CategoryAdd";
import AssetFeedback from "./Pages/Asset/AssetFeedback";
import SocialList from "./Pages/Social/SocialList";
import SocialAdd from "./Pages/Social/SocialAdd";
import SocialEdit from "./Pages/Social/SocialEdit";
import QuestionAdd from "./Pages/Question/QuestonAdd";
import SubCategoryList from "./Pages/SubCategory/CategoryList";
import SubCategoryAdd from "./Pages/SubCategory/CategoryAdd";
import SubCategoryEdit from "./Pages/SubCategory/CategoryEdit";
import AnnouncementList from "./Pages/Announcement/CmsList";
import AnnouncementAdd from "./Pages/Announcement/CmsAdd";
import CointokenAdd from "./Pages/List_cointoken/Cointokenadd";
import Cointokenlist from "./Pages/List_cointoken/Cointokenlist";
import Cointokenedit from "./Pages/List_cointoken/Cointokenedit";
import Exchangelist from "./Pages/List_exchange/Exchangelist";
import ExchangeAdd from "./Pages/List_exchange/Exchangeadd";
import ExchangeEdit from "./Pages/List_exchange/Exchangeedit";
import Viewforms from "./Pages/ViewForms/ViewForm"
import Viewformlists from "./Pages/ViewForms/ViewFormlists"

function App() {
  const [token, setToken] = useState(
    localStorage.getItem("adminkey") ? true : false
  );

  const validateAuth = (comp) => {
    return localStorage.getItem("adminkey") ? comp : <Navigate to={"/"} replace />;
  };

  const protectedRoutes = [
    { path: "/assetadd", element: <AssetAdd /> },
    { path: "/assetlist", element: <AssetList /> },
    { path: "/assetDetail", element: <AssetEdit /> },
    { path: "/assetfeedback", element: <AssetFeedback /> },
    { path: "/cmsadd", element: <CmsAdd /> },
    { path: "/cmslist", element: <CmsList /> },
    { path: "/cmsEdit", element: <CmsEdit /> },
    { path: "/useradd", element: <UserAdd /> },
    { path: "/userlist", element: <UserList /> },
    { path: "/userEdit", element: <UserEdit /> },
    { path: "/networklist", element: <NetworkList /> },
    { path: "/networkadd", element: <NetworkAdd /> },
    { path: "/networkedit", element: <NetworkEdit /> },
    { path: "/categorylist", element: <CategoryList /> },
    { path: "/categoryedit", element: <CategoryEdit /> },
    { path: "/categoryadd", element: <CategoryAdd /> },
    { path: "/sociallist", element: <SocialList /> },
    { path: "/socialadd", element: <SocialAdd /> },
    { path: "/socialedit", element: <SocialEdit /> },
    { path: "/questionlist", element: <SocialList /> },
    { path: "/questionadd", element: <QuestionAdd /> },
    { path: "/questionedit", element: <SocialEdit /> },
    { path: "/cointokenlist", element: <Cointokenlist /> },
    { path: "/cointokenadd", element: <CointokenAdd /> },
    { path: "/cointokenedit", element: <Cointokenedit /> },
    { path: "/exchangelist", element: <Exchangelist /> },
    { path: "/exchangeadd", element: <ExchangeAdd /> },
    { path: "/exchangeedit", element: <ExchangeEdit /> },
    { path: "/subcategorylist", element: <SubCategoryList /> },
    { path: "/addsubcategory", element: <SubCategoryAdd /> },
    { path: "/editsubcategory", element: <SubCategoryEdit /> },
    { path: "/announcementlist", element: <AnnouncementList /> },
    { path: "/addannouncement", element: <AnnouncementAdd /> },
    { path: "/viewform", element: <Viewforms /> },
    { path: "/viewformlists", element: <Viewformlists /> },
  ];

  useEffect(() => {
    const authToken = localStorage.getItem("adminkey");
    setToken(Boolean(authToken));
  }, [token]);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/" element={<Layout />}>
            {protectedRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={validateAuth(route.element)}
              />
            ))}
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="top-center"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          success: {
            className: "fw-600",
            style: {
              textAlign: "center",
              background: "rgb(58 183 27)",
              color: "white",
            },
          },
          error: {
            className: "fw-600",
            style: {
              textAlign: "center",
              background: "#cd1212",
              color: "white",
            },
          },
        }}
      />
    </>
  );
}

export default App;
